import {Component, Input} from '@angular/core';
import {Company} from "../../../interfaces/company.interface";

@Component({
  selector: 'app-special-information',
  templateUrl: './special-information.component.html',
  styleUrls: ['./special-information.component.scss']
})
export class SpecialInformationComponent {

  @Input() reportSearch: any;
  @Input() company: Company;

}
